export default {_name:'image.avatar',module:'Field',view:'Element/Image/Avatar',options:{key:'avatar',sm:4,xs:12,ms:4}}